import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    notifications: [],
    totalCount: 0,
};
export const notificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setNotifications(state, action) {
            state.notifications = [...action.payload, ...state.notifications]
        },
        setTotalCount(state, action) {
            state.totalCount = action.payload;
        },
        reSetNotifications(state, action) {
            state.notifications = [...action.payload,]
        },
    },
});

export const { setNotifications, reSetNotifications, setTotalCount } = notificationSlice.actions;
export default notificationSlice.reducer;
